import Notify from "./notify";
import Metis from "../metis";
import {escapeMetisVariables, unescapeMetisReturnObject} from "./escapeMetis";

const wp = wp_metis;

const notify = new Notify();
const metis = new Metis();

const bundleConfigurationFields = `
  bundleKonfigurationKey
  bundleOberkategorie {
    id
  }
  bundleKonfigurationUnterkategorien {
    bundleUnterkategorie {
      id
    }
    bundleKonfigurationKurse {
      kurs {
        kursnr
      }
    }
    valide
  }
  verwendeteCredits
  maxCredits
  valide
  createTime
`;

class Bundles {

  async getBundleKonfiguration(bundleKonfigurationKey) {
    const request = metis.metisRequest({
      query: `query {
        getBundleKonfiguration(bundleKonfigurationKey: "${bundleKonfigurationKey}") {
          ${bundleConfigurationFields}
        }
      }`,
    });

    const response = await request;

    if (response) {
      return response.getBundleKonfiguration;
    }
  }

  async isBundlekonfigurationValide(bundleKonfigurationKey) {
    const request = metis.metisRequest({
      query: `query {
        isBundlekonfigurationValide(bundleKonfigurationKey: "${bundleKonfigurationKey}")
      }`,
    });

    const response = await request;

    if (response) {
      return response.isBundlekonfigurationValide;
    }
  }

  async addBundleKursAndCreateBundlekonfiguration(bundleOberkategorieId, bundleUnterkategorieId, kursnr) {
    const request = metis.metisRequest({
      query: `mutation {
        addBundleKursAndCreateBundlekonfiguration(
          bundleOberkategorieId: ${bundleOberkategorieId}
          bundleUnterkategorieId: ${bundleUnterkategorieId}
          kursnr: "${kursnr}"
        ) {
          ${bundleConfigurationFields}
        }
      }`,
    });

    const response = await request;

    if (response) {
      return response.addBundleKursAndCreateBundlekonfiguration;
    }
  }

  async addKursToBundlekonfiguration(bundleKonfigurationKey, bundleUnterkategorieId, kursnr) {
    const request = metis.metisRequest({
      query: `mutation {
        addKursToBundlekonfiguration(
          bundleKonfigurationKey: "${bundleKonfigurationKey}"
          bundleUnterkategorieId: ${bundleUnterkategorieId}
          kursnr: "${kursnr}"
        ) {
          ${bundleConfigurationFields}
        }
      }`,
    });

    const response = await request;

    if (response) {
      return response.addKursToBundlekonfiguration;
    }
  }

  async deleteBundleKurs(bundleKonfigurationKey, bundleUnterkategorieId, kursnr) {
    const request = metis.metisRequest({
      query: `mutation {
       deleteBundleKurs(
          bundleKonfigurationKey: "${bundleKonfigurationKey}"
          bundleUnterkategorieId: ${bundleUnterkategorieId}
          kursnr: "${kursnr}"
        ) {
          ${bundleConfigurationFields}
        }
      }`,
    });

    const response = await request;

    if (response) {
      return response.deleteBundleKurs;
    }
  }
}

export default Bundles;
